import React from 'react'

export default function DonaQRCodeTestRead() {
  return (
    <div>DonaQRCodeTestRead</div>
  )
}
